import React from "react"
import { Package } from "./entities/package"

const PaketMC = ({ data, addItem }) => {
  if (!data) return null

  const BRONS = data?.find(item => item.sellerArticlePackageMasterId === 10157)
  const SILVER = data?.find(item => item.sellerArticlePackageMasterId === 10158)
  const GULD = data?.find(item => item.sellerArticlePackageMasterId === 10159)

  return (
    <div
      className="flex flex-col md:flex-row"
      style={{
        margin: "0",
        color: "#121212",
        textAlign: "left",
      }}
    >
      <Package
        data={BRONS}
        image={require("./../images/mcBRONZE.png")}
        onClick={() =>
          addItem({
            title: BRONS.descriptionHeader,
            sub: BRONS.descriptionHeader,
            price: BRONS.masterPrice,
            vat: BRONS.masterVat,
            id: BRONS.sellerArticlePackageMasterId,
          })
        }
      />
      <Package
        data={SILVER}
        image={require("./../images/mcSILVER.png")}
        onClick={() =>
          addItem({
            title: SILVER.descriptionHeader,
            sub: SILVER.descriptionHeader,
            price: SILVER.masterPrice,
            vat: SILVER.masterVat,
            id: SILVER.sellerArticlePackageMasterId,
          })
        }
      />
      <Package
        data={GULD}
        image={require("./../images/mcGOLD2.png")}
        onClick={() =>
          addItem({
            title: GULD.descriptionHeader,
            sub: GULD.descriptionHeader,
            price: GULD.masterPrice,
            vat: GULD.masterVat,
            id: GULD.sellerArticlePackageMasterId,
          })
        }
      />
    </div>
  )
}

export default PaketMC
